/**
 * Page Show Title Formatter.
 * Toggles the `show_title` boolean on a Page record.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.pageShowTitleFormatter = function(value, row) {
    let domainId = $('#domain_id').val();
    let url = '/domains/show/pages/toggle/' + domainId + '/' + row.id;

    return toggleableFormatter(value, row, 'show_title', url);
};
